export const LightningIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.74949 8.44907H5.44351C4.45436 8.44907 3.95978 8.44907 3.74897 8.12293C3.53815 7.79687 3.73902 7.34253 4.14075 6.43389L5.34851 3.70215C5.71377 2.876 5.89641 2.46292 6.25071 2.23146C6.60501 2 7.05466 2 7.95406 2H9.34699C10.4395 2 10.9858 2 11.1918 2.3569C11.3979 2.7138 11.1269 3.19059 10.5848 4.14415L9.87019 5.40125C9.60073 5.8753 9.46599 6.11233 9.46786 6.30635C9.47033 6.5585 9.60439 6.7908 9.82099 6.918C9.98766 7.01593 10.2592 7.01593 10.8023 7.01593C11.4889 7.01593 11.8323 7.01593 12.0111 7.1348C12.2433 7.2892 12.3649 7.56547 12.3223 7.84213C12.2895 8.05507 12.0586 8.3104 11.5967 8.82113L7.90666 12.9015C7.18186 13.703 6.81946 14.1037 6.57611 13.9769C6.33275 13.8501 6.44962 13.3215 6.68333 12.2641L7.1412 10.1931C7.31913 9.388 7.40813 8.98547 7.19413 8.71727C6.98013 8.44907 6.56991 8.44907 5.74949 8.44907Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
};
